<template>
    <div class="top_fun">
        <el-card shadow="never">
            <div class="top_fun_con" @click="deleteFlag=false">
                <div class="arrow left" v-show="isOverFlow" @click.stop="arrowHandle(1)">
					<i class="el-icon-arrow-left"></i>
				</div>
                <div class="item_con" ref="item_wrap">
					<div class="item_condiv" ref="itemcon">
						<div class="item" :title="item.systemName" @click="itemHandle(1,item)" v-for="item in fastFnData" :key="item.id">
							<div class="bg">
								<div class="delete" v-if="funDeleteFlag" @click.stop="itemHandle(2,item)"></div>
								<img :src="item.attachments?fileServerUrl+item.attachments[0].filePath:myImg" alt="">
							</div>
							<p>{{item.systemName}}</p>
						</div>
					</div>
				</div>
                <!-- <div class="item_con">
                    <div class="item_condiv" ref="itemcon">
						<div class="item" @click="itemHandle(1)">
							<div class="bg">
								<div class="delete" v-if="deleteFlag" @click.stop="itemHandle(2)"></div>
								<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAEU0lEQVRoQ+Wby28bRRzHv7+ZtXez8SvBiUvpofdeOPdWCVSkAlIR9MgF8Q/AlUPhzOMP4MaBQypSRbRSEUi+8boAhx6REC81ieXEj2y99s780K7jNHWT9WbXxLbGl8jxzPx+n3n9HjNDmPZnAxJrl3Nod3MVHUjFSjJcyZIJFhP3wr+gSGwAJocYATEpYoKnJEm1LyyFUmGA3T8GuAU1TRWHgrN8QsBezSmv9vIB5W0OWGRpbrwuWaQt7vutptOHs93L2gHpgetwSn7JDZC34R+O2DRJT2rLBlvo+2277eEaemnEnR1449JSwdovaulYaQROq45QvaAbVDq49ffjs7SZHLgOq9gtVpS282cR8H+XlcLvdwqdfVxDkERWMuBvastuV5WONpskLZ9nmQDsFWQb17cPJomdCLzy7UrZ9+TypIbm4XfbVQd7L++14nSJBS7fK68MVG5pHmCS6pCTg8etV1t7p5U/FXiRRnYcLm6kTwYO12xPlZP26jyW8xzZOmlNPwtch+U2q2tzu0El7d1wI1tt7I7v3s8AF78uVufN9CRlHC8XmazXOo3j/38aeOPSkmv3VtIKmMd6nu/sHXdOngIubBbWZ+1BTbvTIo/sje7OqN0nwHU4bru6Om2B89CeV2o0R773EXDpQWk18PPOPCg4bR0su99rv9Juhu0OgTcg3VJ1PW3UMwAuEvQNAoqxyjIegdVdKXKRw6/0YAkkb4JwIa4eAx2GuJ8D/k3VGTbYazd2wtByCPxFbdktp7O7ESzzdwQktNv8qwBehyStFd8D6MUkEAy0mOiltNBeS7bw9vZBBJzFhQyg3yWm26FCAD+M92PpavQ783UNvSNI/hJ9BX8fD01Xwg5l4tsWxOdJOmi8zMjljICX769dSJupUNDvgen9UGmLxFtxyijmf4a8/Ka06C+t8FP4XRK9EFcvYH2HQFdB/ImE+DQNcJg5Obix+4ii9WtXa2kaidbhggCHunp+Y5tQv+y47W5qc7RQwKVCk7BVLbqTdteY4V8oYKBDlbuVSl9YrglTOq8Dj4qbxeeUtG0TgKXyfSps1ta1VKkzkIs0pYWSAS1vrdcYWpowwgShKIsNXjSzFNpicr+qPp8lu7FIUzo6y3K3qhfTTucsI8zQv5+nazlinBmwtOjH8wwengDPaEpbQvxwbuHhiDac0rPatELgLEspTd1o05qVWYpGmPkmgA+AyQkAAn8pSXyUBvRoOodmaVaOB4ngN7D1EKDEp5Gk+R0hxYO00JHjMSvXkiX9KTR+HsXHsYkDwocAXQH4Y0nis7TAkWtpXPBgXHhoXgLAuBSPcUk8E9O0xiXizTtqAWDWYVrouph2XBoym3UgHhKbduUhZDbrUstwLZt1bSkKvYy6mHYYbJp19fAQOsvNgLRBetZ6qS+XjgQv0khnvj581NsmXRA/gjbqCcDxhWXMI4/x3cSYZzzj4MY81DrNfsz5U7z/AN5nQM0YJur1AAAAAElFTkSuQmCC" alt="">
							</div>
							<p>开标人员登记-工程</p>
						</div>
					</div>
                </div> -->
                <div class="arrow right" v-show="isOverFlow" @click.stop="arrowHandle(2)">
					<i class="el-icon-arrow-right"></i>
				</div>
				<div class="edit">
					<div class="item add" @click.stop="funHandle(1)">
						<div class="bg">
							<i class="el-icon-circle-plus-outline"></i>
						</div>
						<p>添加功能模块</p>
					</div>
					<div class="item delete" @click.stop="funHandle(2)">
						<div class="bg">
							<i class="el-icon-remove-outline"></i>
						</div>
						<p>删除功能模块</p>
					</div>
				</div>
            </div>
        </el-card>
        <addFun :addFundialogVisiter="dialogVisible" @addfnclose="addfncloseHandle" ref="addfndialog"></addFun>
    </div>
</template>

<script>
import addFun from '../center/add-fun.vue';
import {
	apiAuditList,apiwbschedulemanagementlist,apiworkBenchIndexProjectIndex,
	apiAuditCount,apijwtToJsgc,apijwtToZfcg,apijwtToBjm,apijwtToField,apiwbschedulemanagementupdateCompleteStatus,
	apiwbschedulemanagementdelete,apiwbschedulemanagementmove,apiwbconveniententranceconvenientEntranceList,
	apiwbconveniententrancedelete,apiwbconveniententrancedeleteCustomize,
	apiwbconveniententrancesort,apijwtToSystem,apifilePath} from '@/server/common';
import {APIwbconveniententranceconvenientList} from '@/server/home-center'

export default {
    components:{
        addFun
    },
    data(){
        return {
            deleteFlag:false,
            dialogVisible:false,
			fastFnData:[],
            arrowNum: 0,
            isOverFlow: false,
        }
    },
    watch:{
        fastFnData(val){
            if(val.length>0){
                // 判断item_wrap内容是否超出
                this.isOverFlow = this.$refs.item_wrap.scrollWidth > this.$refs.item_wrap.clientWidth;
            }
        }
    },
    created(){
        this.APIwbconveniententranceconvenientList();
    },
    methods:{
        fetchData(){
            this.APIwbconveniententranceconvenientList()
        },
        APIwbconveniententranceconvenientList(){
			APIwbconveniententranceconvenientList({
				page:1,
				rows:100,
			}).then(({data})=>{
				this.fastFnData=data.rows||[];
			})
		},
        arrowHandle(type){
			let lenght=this.fastFnData.length;
			if(type==1){
				if(this.arrowNum<=0){
					this.$refs.itemcon.style.transform=`translateX(0px)`;
					return;
				}else{
					this.arrowNum=this.arrowNum-1;
					this.arrowLong=this.arrowLong+140;
					this.$refs.itemcon.style.transform=`translateX(${this.arrowLong}px)`;
				}
			}else{
				if(this.arrowNum+3>=lenght){
					return;
				}else{
					this.arrowNum=this.arrowNum+1;
					this.arrowLong=-this.arrowNum*140;
					this.$refs.itemcon.style.transform=`translateX(${this.arrowLong}px)`;
				}
			}
		},
        funHandle(type){//顶部添加删除按钮1添加2删除
            if(type==1){
				this.dialogVisible=true;
				this.$refs.addfndialog.init();
			}else if(type==2){
				this.deleteFlag=!this.deleteFlag;
			}
        },
        itemHandle(type,arg){
			if(type==1){
				if(arg.systemType==1){
					apijwtToJsgc({redUrl:arg.systemUrl,title:arg.systemName,field2:arg.systemTypeName,jwtType:arg.jwtType}).then(({data})=>{
						if(data.code=='1'){
							if(arg.jwtType==1){
								addPanel(arg.systemName,data.data)
							}else{
								window.open(data.data);
							}
						}else{
							this.$alert(data.msg);
						}
					})
				}
				if(arg.systemType==2){
					apijwtToZfcg({redUrl:arg.systemUrl,title:arg.systemName,field2:arg.systemTypeName,jwtType:arg.jwtType}).then(({data})=>{
						if(data.code=='1'){
							if(arg.jwtType==1){
								addPanel(arg.systemName,data.data)
							}else{
								window.open(data.data);
							}
						}else{
							this.$alert(data.msg);
						}
					})
				}
			}else if(type==2){
				this.$confirm('是否删除本条记录？','提示',{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(()=>{
					apiwbconveniententrancedeleteCustomize({id:arg.id,systemConfigId:arg.systemConfigId}).then(({data})=>{
						if(data.code=='1'){
							this.APIwbconveniententranceconvenientList();
						}else{
							this.$message.error(data.msg)
						}
					})
				}).catch(()=>{})
			}
		},
        addfncloseHandle(){
            this.dialogVisible=false;
			this.fetchData();
        }
    }
}
</script>

<style lang="less" scoped>
.top_fun{
    .top_fun_con{
        padding: 16px 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        overflow-x: auto;
        .arrow{
            height: 92px;
            width: 24px;
            background: rgba(0,0,0,.03);
            border-radius: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            i{
                font-size: 20px;
            }
        }
        .item_con{
            width: calc(100% - 300px);
            overflow: hidden;
            .item_condiv{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                transform:translateX(0);
                padding: 0 10px;
                .item{
                    width: 140px;
                    text-align: center;
                    flex: none;
                    cursor: pointer;
                    .bg{
                        width: 60px;
                        height: 60px;
                        border-radius: 25px;
                        margin: 0 auto;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        position: relative;
                        .delete{
                            position: absolute;
                            width: 12px;
                            height: 12px;
                            border-radius: 50%;
                            background: red;
                            right: 0;
                            top: 0;
                            color: #ffffff;
                            text-align: center;
                            line-height: 12px;
                            &:after{
                                content: '';
                                width: 6px;
                                height: 2px;
                                background: #ffffff;
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%,-50%);
                            }
                        }
                        img{
                            width: 60px;
                            height: 60px;
                        }
                    }
                    p{
                        margin: 15px 0 0 0;
                        width: 100%;
                        overflow: hidden;/*超出部分隐藏*/
                        text-overflow:ellipsis;/* 超出部分显示省略号 */
                        white-space: nowrap;/*规定段落中的文本不进行换行 */
                    }
                }
            }
        }
        .edit{
            margin-left: 20px;
            width: 250px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .item{
                width: 50%;
                text-align: center;
                flex: none;
                cursor: pointer;
                >div{
                    margin: 0 auto;
                    margin-bottom: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    i{
                        font-size: 30px;
                    }
                }
                .bg{
                    width: 60px;
                    height: 60px;
                    background: rgba(0, 0, 0, 0.04);
                    border-radius: 25px;
                }
            }
        }
    }
}
</style>